import { render, staticRenderFns } from "./basecastigosytelegramas.vue?vue&type=template&id=2fa43af2"
import script from "./basecastigosytelegramas.vue?vue&type=script&lang=js"
export * from "./basecastigosytelegramas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports